// routes
import {PATH_DASHBOARD} from "../../../routes/path";
// components
import SvgColor from "../../../components/svg-color";
import {ALL_ROLES, OPERATORS_GROUP, USER_TYPES_GROUP} from "../../../constants";
import Iconify from "../../../components/Iconify";

// ----------------------------------------------------------------------

export const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{width: 1, height: 1}}/>;


// ----------------------------------------------------------------------

const ICONS = {
    blog: icon("ic_blog"),
    discount: icon("ic_discount"),
    cart: icon("ic_cart"),
    chat: icon("ic_chat"),
    mail: icon("ic_mail"),
    user: icon("ic_user"),
    file: icon("ic_file"),
    lock: icon("ic_lock"),
    label: icon("ic_label"),
    blank: icon("ic_blank"),
    kanban: icon("ic_kanban"),
    folder: icon("ic_folder"),
    banking: icon("ic_banking"),
    booking: icon("ic_booking"),
    invoice: icon("ic_invoice"),
    calendar: icon("ic_calendar"),
    disabled: icon("ic_disabled"),
    external: icon("ic_external"),
    menuItem: icon("ic_menu_item"),
    ecommerce: icon("ic_ecommerce"),
    analytics: icon("ic_analytics"),
    dashboard: icon("ic_dashboard"),
    bus: icon("ic_bus"),
    report: icon("ic_report"),
    priceList: icon("ic_price_list"),
    stationList: icon("ic_station_list"),
    monthly: icon("ic_monthly"),
    locations: icon("ic_locations"),
    relations: icon("ic_relations"),
    seats: <Iconify icon="material-symbols:event-seat"/>,
    garage: <Iconify icon="mdi:garage-variant"/>,
    platforms: icon("ic_relations"),
    departures: icon("ic_deparutres"),
    times: icon("ic_times"),
    reports: icon("ic_reports"),
    barriers: <Iconify icon="mdi:entry-room"/>,
    invoices: icon("ic_invoices"),
    carrier: icon("ic_carrier"),
    customers: icon("ic_customer"),
    insurance: icon("ic_insurance"),
    adminRoutes: <Iconify icon="dashicons:admin-links"/>,
    bugs: <Iconify icon="solar:bug-bold-duotone"/>,
    requests: <Iconify icon="ic:twotone-pending-actions"/>,
    updates: <Iconify icon="solar:check-read-bold-duotone"/>,
    allotments: <Iconify icon="ion:ticket"/>,
    comments: <Iconify icon="mingcute:comment-fill"/>,
    promoNotifications: <Iconify icon="solar:bell-bing-bold-duotone"/>,


};

const CITY_ALL_USERS = [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER,
    USER_TYPES_GROUP.CITY_TRANSPORT];
const CITY_MANAGE_ROLES = [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin,
    OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher];
const CITY_SELL_ROLES = [...CITY_MANAGE_ROLES, OPERATORS_GROUP.operator];
const WITHOUT_CASHIER = ALL_ROLES.filter(item => item !== OPERATORS_GROUP.cashier);

const cityItem = (title, path, icon, roles = CITY_MANAGE_ROLES, extra = {}) => ({
    title,
    path,
    icon,
    needPrimaryUser: true,
    allowedUserTypes: CITY_ALL_USERS,
    roles,
    ...extra
});

export const navConfigUzice = [
    {
        subheader: "Početna",
        needPrimaryUser: true,
        allowedUserTypes: CITY_ALL_USERS,
        items: [
            cityItem("Lista Računa", PATH_DASHBOARD.general.invoices, ICONS.invoices, CITY_SELL_ROLES),
            cityItem("Lista artikala", PATH_DASHBOARD.general.stationServices, ICONS.cart, CITY_SELL_ROLES),
            cityItem("Izveštaji", PATH_DASHBOARD.reports.root, ICONS.reports, [...CITY_SELL_ROLES, OPERATORS_GROUP.cashier], {
                children: [
                    {title: "Evidencija prometa", path: PATH_DASHBOARD.reports.overview},
                    {title: "Pregled prodatih karata i robe", path: PATH_DASHBOARD.reports.overviewTicketAndOther},
                    {title: "Izveštaj akcija", path: PATH_DASHBOARD.reports.actionsReport, roles: CITY_SELL_ROLES}
                ]
            })
        ]
    },
    {
        subheader: "Gradski prevoz",
        needPrimaryUser: true,
        allowedUserTypes: CITY_ALL_USERS,
        roles: CITY_SELL_ROLES,
        items: [
            cityItem("Gradske linije", PATH_DASHBOARD.cityTransport.lines, ICONS.bus),
            cityItem("Izuzeci", PATH_DASHBOARD.cityTransport.exceptions, ICONS.calendar),
            cityItem("Trase i stajališta", PATH_DASHBOARD.cityTransport.routes, ICONS.menuItem),
            cityItem("Tarifni sistem", PATH_DASHBOARD.cityTransport.zones, ICONS.banking, CITY_MANAGE_ROLES, {
                children: [
                    {title: "Tarifne zone", path: PATH_DASHBOARD.cityTransport.zones},
                    {title: "Zonski cenovnik", path: PATH_DASHBOARD.cityTransport.fares},
                    {title: "Periodične karte", path: PATH_DASHBOARD.cityTransport.passes}
                ]
            }),
            cityItem("Izdavanje i dopuna kartica", PATH_DASHBOARD.cityTransport.sale, ICONS.cart, CITY_SELL_ROLES),
            cityItem("Kartice i transakcije", PATH_DASHBOARD.cityTransport.cards, ICONS.booking, CITY_SELL_ROLES),
            cityItem("Validacije kartica", PATH_DASHBOARD.cityTransport.validations, ICONS.label),
            cityItem("Lista fiskalnih računa", PATH_DASHBOARD.cityTransport.invoices, ICONS.invoices, CITY_SELL_ROLES),
            cityItem("Razduženje zaposlenih", PATH_DASHBOARD.cityTransport.employeeSettlement, ICONS.banking, CITY_SELL_ROLES),
            cityItem("Finansijski izveštaji", PATH_DASHBOARD.cityTransport.tickets, ICONS.analytics, CITY_SELL_ROLES, {
                children: [
                    {title: "DPPK - Detaljni pregled prodatih karata", path: PATH_DASHBOARD.cityTransport.tickets},
                    {title: "Izveštaj po kasi i uređaju", path: PATH_DASHBOARD.cityTransport.deviceReport,
                        roles: CITY_MANAGE_ROLES},
                    {title: "FINP - Finansijski izveštaj po načinu plaćanja", path: PATH_DASHBOARD.cityTransport.financeReport,
                        roles: CITY_MANAGE_ROLES}
                ]
            })
        ]
    },
    {
        subheader: "Dispečer centar",
        needPrimaryUser: true,
        allowedUserTypes: CITY_ALL_USERS,
        roles: CITY_MANAGE_ROLES,
        items: [
            cityItem("Rasporedi", PATH_DASHBOARD.dispatchCenter.scheduleDay, ICONS.calendar,
                CITY_MANAGE_ROLES, {
                    children: [
                        {title: "Po polascima", path: PATH_DASHBOARD.dispatchCenter.scheduleDay},
                        {title: "Po turnusima", path: PATH_DASHBOARD.dispatchCenter.scheduleWeek}
                    ]
                }),
            cityItem("Turnusi", PATH_DASHBOARD.dispatchCenter.turnus, ICONS.folder),
            cityItem("Lista rasporeda", PATH_DASHBOARD.dispatchCenter.turnusSchedule, ICONS.booking),
            cityItem("Polasci bez vozača", PATH_DASHBOARD.dispatchCenter.unassigned, ICONS.disabled),
            cityItem("Praćenje flote", PATH_DASHBOARD.dispatchCenter.fleet, ICONS.bus),
            cityItem("Putni nalozi", PATH_DASHBOARD.dispatchCenter.travelOrders, ICONS.file),
            cityItem("Saobraćajni izveštaji", PATH_DASHBOARD.dispatchCenter.driverReport, ICONS.analytics, CITY_MANAGE_ROLES, {
                children: [
                    {title: "Izveštaj po vozačima", path: PATH_DASHBOARD.dispatchCenter.driverReport},
                    {title: "Izveštaj po vozilu", path: PATH_DASHBOARD.cityTransport.vehicleReport},
                    {title: "Izveštaj kontrolora", path: PATH_DASHBOARD.cityTransport.inspectorReport},
                    {title: "Kilometraža po liniji", path: PATH_DASHBOARD.cityTransport.kilometers},
                    {title: "Izveštaj o saobraćaju i prodaji", path: PATH_DASHBOARD.cityTransport.reports}
                ]
            }),
            cityItem("Vozači", PATH_DASHBOARD.dispatchCenter.drivers, ICONS.user),
            cityItem("Pogoni i garaže", PATH_DASHBOARD.dispatchCenter.depots, ICONS.garage)
        ]
    },
    {
        subheader: "Administracija",
        needPrimaryUser: true,
        allowedUserTypes: CITY_ALL_USERS,
        roles: CITY_MANAGE_ROLES,
        items: [
            cityItem("Vozila - sopstvena", PATH_DASHBOARD.bus.root, ICONS.bus, CITY_MANAGE_ROLES, {
                children: [
                    {title: "Lista vozila", path: PATH_DASHBOARD.bus.list},
                    {title: "Dodavanje vozila", path: PATH_DASHBOARD.bus.new}
                ]
            }),
            cityItem("Stanice", PATH_DASHBOARD.stationList.root, ICONS.stationList, CITY_MANAGE_ROLES, {
                children: [
                    {title: "Lista stanica", path: PATH_DASHBOARD.stationList.list},
                    {title: "Dodavanje stanice", path: PATH_DASHBOARD.stationList.new}
                ]
            }),
            cityItem("Cenovnici", PATH_DASHBOARD.priceList.root, ICONS.priceList,
                [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin], {
                    children: [
                        {title: "Lista cenovnika", path: PATH_DASHBOARD.priceList.list},
                        {title: "Dodavanje cenovnika", path: PATH_DASHBOARD.priceList.new}
                    ]
                }),
            cityItem("Vrste karata", PATH_DASHBOARD.discounts.root, ICONS.discount,
                [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin], {
                    children: [
                        {title: "Lista vrsta karata", path: PATH_DASHBOARD.discounts.list},
                        {title: "Dodavanje vrste karte", path: PATH_DASHBOARD.discounts.new}
                    ]
                }),
            cityItem("Artikli", PATH_DASHBOARD.items.root, ICONS.cart,
                [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin], {
                    children: [
                        {title: "Lista artikala", path: PATH_DASHBOARD.items.list},
                        {title: "Dodavanje artikla", path: PATH_DASHBOARD.items.new},
                        {title: "Cene po cenovniku", path: PATH_DASHBOARD.items.rateCardItems}
                    ]
                }),
            cityItem("Praznici", PATH_DASHBOARD.holidays.root, ICONS.calendar, CITY_MANAGE_ROLES, {
                children: [
                    {title: "Lista praznika", path: PATH_DASHBOARD.holidays.list},
                    {title: "Dodavanje praznika", path: PATH_DASHBOARD.holidays.new}
                ]
            }),
            cityItem("Baza kupaca", PATH_DASHBOARD.customers.root, ICONS.customers, CITY_SELL_ROLES, {
                children: [
                    {title: "Lista kupaca", path: PATH_DASHBOARD.customers.list},
                    {title: "Dodavanje kupaca", path: PATH_DASHBOARD.customers.new}
                ]
            }),
            cityItem("Zaposleni", PATH_DASHBOARD.operators.root, ICONS.user,
                [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin], {
                    children: [
                        {title: "Lista zaposlenih", path: PATH_DASHBOARD.operators.list},
                        {title: "Dodavanje zaposlenog", path: PATH_DASHBOARD.operators.new}
                    ]
                })
        ]
    }
]
export const navConfig = [
    // ----------------------------------------------------------------------
    {
        subheader: "Admin",
        needPrimaryUser: true,
        uid: "0UIMxuKls9hjEjDDwcFJKv8DZmn1",
        roles: ALL_ROLES.filter(item => {
            return [OPERATORS_GROUP.superAdmin].includes(item);
        }),
        items: [
            {
                title: "Zabranjene stranice po korisniku",
                needPrimaryUser: true,
                roles: [OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.admin.routes,
                icon: ICONS.adminRoutes,
            },
            {
                title: "Provera dostupnosti polaska",
                needPrimaryUser: true,
                roles: [OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.admin.availabilityCheck,
                icon: ICONS.departures,
            },
        ]
    },
    {
        subheader: "Početna",
        needPrimaryUser: true,
        allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
        items: [
            {
                title: "Statistika prodaje",
                needPrimaryUser: true,
                primaryOnly: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.admin.statistics,
                icon: ICONS.analytics
            },
            {
                title: "Prodaja",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: ALL_ROLES.filter(item => {
                    return ![OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.cashier].includes(item);
                }),
                path: PATH_DASHBOARD.general.app,
                icon: ICONS.bus
            },
            {
                title: "Lista artikala",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: ALL_ROLES.filter(item => {
                    return ![OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.publisher, OPERATORS_GROUP.informer,
                        OPERATORS_GROUP.cashier].includes(item);
                }),
                path: PATH_DASHBOARD.general.stationServices,
                icon: ICONS.bus
            },
            {
                title: "Izveštaji",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: ALL_ROLES.filter(item => {
                    return ![OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.publisher,
                        OPERATORS_GROUP.informer].includes(item);
                }),
                path: PATH_DASHBOARD.reports.root,
                icon: ICONS.reports,
                children: [
                    {title: "Evidencija prometa", path: PATH_DASHBOARD.reports.overview},
                    {title: "Pregled prodatih karata i robe", path: PATH_DASHBOARD.reports.overviewTicketAndOther},
                    {title: "Izveštaj validiranih karata", path: PATH_DASHBOARD.reports.validatedTicketReport},
                    {title: "Izveštaj akcija", path: PATH_DASHBOARD.reports.actionsReport, roles: WITHOUT_CASHIER},
                    {title: "Likvidatura", path: PATH_DASHBOARD.reports.liquidation, allowedUserTypes: [USER_TYPES_GROUP.CARRIER]},
                    {title: "Izveštaj o upotrebi preplatničkih karata", path: PATH_DASHBOARD.reports.multiPassValidations, allowedUserTypes: [USER_TYPES_GROUP.CARRIER], roles: WITHOUT_CASHIER},
                    {title: "Izveštaj mesečnih karata po naručiocu", path: PATH_DASHBOARD.reports.multiPassesByClient, allowedUserTypes: [USER_TYPES_GROUP.CARRIER], roles: WITHOUT_CASHIER},
                ]
            },
            {
                title: "Lista Računa",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: ALL_ROLES.filter(item => {
                    return ![OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.publisher,
                        OPERATORS_GROUP.informer, OPERATORS_GROUP.cashier].includes(item);
                }),
                path: PATH_DASHBOARD.general.invoices,
                icon: ICONS.invoices
            },
            {
                title: "Lista autobuskih karata",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: ALL_ROLES.filter(item => {
                    return ![OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.publisher,
                        OPERATORS_GROUP.informer, OPERATORS_GROUP.cashier].includes(item);
                }),
                path: PATH_DASHBOARD.general.busTickets,
                icon: ICONS.invoices
            },
            {
                title: "Lista prodatih usluga",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: ALL_ROLES.filter(item => {
                    return ![OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.publisher,
                        OPERATORS_GROUP.informer, OPERATORS_GROUP.cashier].includes(item);
                }),
                path: PATH_DASHBOARD.general.soldServices,
                icon: ICONS.invoices
            },
            {
                title: "Mesečne karte",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                path: PATH_DASHBOARD.monthlyTicketsList.root,
                roles:ALL_ROLES.filter(item => {
                    return ![OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.publisher,
                        OPERATORS_GROUP.informer, OPERATORS_GROUP.cashier].includes(item);
                }),
                icon: ICONS.monthly,
                children: [
                    {title: "Lista mesečnih karti", path: PATH_DASHBOARD.monthlyTicketsList.list},
                    {title: "Dodavanje mesečne karte", path: PATH_DASHBOARD.monthlyTicketsList.new},
                ]
            },
        ]
    },
    // Gradski prevoz je zasebna kartica, ali linije koje se ovde prave su obične linije sa
    // vrstom saobraćaja Gradska - zato ih dispečer centar vidi bez ijedne izmene.
    {
        subheader: "Gradski prevoz",
        needPrimaryUser: true,
        allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
        roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher],
        items: [
            {
                title: "Gradske linije", path: PATH_DASHBOARD.cityTransport.lines, icon: ICONS.bus,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher]
            },
            {
                title: "Izuzeci", path: PATH_DASHBOARD.cityTransport.exceptions, icon: ICONS.calendar,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher]
            },
            {
                title: "Trase i stajališta", path: PATH_DASHBOARD.cityTransport.routes, icon: ICONS.menuItem,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher]
            },
            {
                title: "Tarifni sistem", path: PATH_DASHBOARD.cityTransport.zones, icon: ICONS.banking,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher],
                children: [
                    {title: "Tarifne zone", path: PATH_DASHBOARD.cityTransport.zones},
                    {title: "Zonski cenovnik", path: PATH_DASHBOARD.cityTransport.fares},
                    {title: "Periodične karte", path: PATH_DASHBOARD.cityTransport.passes}
                ]
            },
            {
                title: "Izdavanje i dopuna kartica", path: PATH_DASHBOARD.cityTransport.sale, icon: ICONS.cart,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager,
                    OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.operator]
            },
            {
                title: "Kartice i transakcije", path: PATH_DASHBOARD.cityTransport.cards, icon: ICONS.booking,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager,
                    OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.operator]
            },
            {
                title: "Validacije kartica", path: PATH_DASHBOARD.cityTransport.validations, icon: ICONS.label,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher]
            },
            {
                title: "Lista fiskalnih računa", path: PATH_DASHBOARD.cityTransport.invoices, icon: ICONS.invoices,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager,
                    OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.operator]
            },
            {
                title: "Razduženje zaposlenih", path: PATH_DASHBOARD.cityTransport.employeeSettlement, icon: ICONS.banking,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager,
                    OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.operator]
            },
            {
                title: "Finansijski izveštaji", path: PATH_DASHBOARD.cityTransport.tickets, icon: ICONS.analytics,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager,
                    OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.operator],
                children: [
                    {title: "DPPK - Detaljni pregled prodatih karata", path: PATH_DASHBOARD.cityTransport.tickets},
                    {title: "Izveštaj po kasi i uređaju", path: PATH_DASHBOARD.cityTransport.deviceReport,
                        roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager,
                            OPERATORS_GROUP.dispatcher]},
                    {title: "FINP - Finansijski izveštaj po načinu plaćanja", path: PATH_DASHBOARD.cityTransport.financeReport,
                        roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager,
                            OPERATORS_GROUP.dispatcher]}
                ]
            }
        ]
    },
    // Stanica sa sopstvenim prevozom je vlasnik svojih polazaka isto kao prevoznik,
    // pa raspored radi bez izmena na serveru - opseg je uvek operater iz tokena.
    {
        subheader: "Dispečer centar",
        needPrimaryUser: true,
        allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
        roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager,
            OPERATORS_GROUP.dispatcher],
        items: [
            {
                title: "Rasporedi", path: PATH_DASHBOARD.dispatchCenter.scheduleDay, icon: ICONS.calendar,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher],
                children: [
                    {title: "Po polascima", path: PATH_DASHBOARD.dispatchCenter.scheduleDay},
                    {title: "Po turnusima", path: PATH_DASHBOARD.dispatchCenter.scheduleWeek}
                ]
            },
            {
                title: "Turnusi", path: PATH_DASHBOARD.dispatchCenter.turnus, icon: ICONS.folder,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher]
            },
            {
                title: "Lista rasporeda", path: PATH_DASHBOARD.dispatchCenter.turnusSchedule, icon: ICONS.booking,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher]
            },
            {
                title: "Saobraćajni izveštaji", path: PATH_DASHBOARD.dispatchCenter.driverReport, icon: ICONS.analytics,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher],
                children: [
                    {title: "Izveštaj po vozačima", path: PATH_DASHBOARD.dispatchCenter.driverReport},
                    {title: "Izveštaj po vozilu", path: PATH_DASHBOARD.cityTransport.vehicleReport},
                    {title: "Izveštaj kontrolora", path: PATH_DASHBOARD.cityTransport.inspectorReport},
                    {title: "Kilometraža po liniji", path: PATH_DASHBOARD.cityTransport.kilometers},
                    {title: "Izveštaj o saobraćaju i prodaji", path: PATH_DASHBOARD.cityTransport.reports}
                ]
            },
            {
                title: "Praćenje flote", path: PATH_DASHBOARD.dispatchCenter.fleet, icon: ICONS.bus,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher]
            },
            {
                title: "Putni nalozi", path: PATH_DASHBOARD.dispatchCenter.travelOrders, icon: ICONS.file,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher]
            },
            {
                title: "Polasci bez vozača", path: PATH_DASHBOARD.dispatchCenter.unassigned, icon: ICONS.disabled,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher]
            },
            {
                title: "Vozači", path: PATH_DASHBOARD.dispatchCenter.drivers, icon: ICONS.user,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher]
            },
            {
                title: "Alarmi i obaveštenja", path: "#", icon: ICONS.mail, disabled: true, caption: "uskoro",
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher]
            },
            {
                title: "Vozila", path: "#", icon: ICONS.bus, disabled: true, caption: "uskoro",
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher]
            },
            {
                title: "Pogoni i garaže", path: PATH_DASHBOARD.dispatchCenter.depots, icon: ICONS.garage,
                needPrimaryUser: true, allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.manager, OPERATORS_GROUP.dispatcher]
            },
        ]
    },
    {
        subheader: 'PANEL PREVOZNIKA',
        needPrimaryUser: true,
        allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
        items: [
            {title: "Cenovnici", path: PATH_DASHBOARD.preview.priceList, icon: ICONS.priceList,needPrimaryUser: true,
                roles:[OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin], allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION]},
            {title: "Relacije prevoznika", path: PATH_DASHBOARD.preview.linesList, icon: ICONS.relations,needPrimaryUser: true,
                roles:[OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin], allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION]},
            {title: "Redovi vožnje i polasci", path: PATH_DASHBOARD.preview.departuresList, icon: ICONS.departures,needPrimaryUser: true,
                roles:[OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.informer],allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION]},
            {title: "Alotmani", path: PATH_DASHBOARD.preview.allotments, icon: ICONS.allotments,needPrimaryUser: true,
                roles:[OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin], allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION]},
            {title: "Dostupni alotmani", path: PATH_DASHBOARD.preview.currentAllotments, icon: ICONS.allotments,needPrimaryUser: true,
                roles:[OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin], allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION]},
            {title: "Vozila prevoznika", path: PATH_DASHBOARD.preview.driveParkList, icon: ICONS.bus,needPrimaryUser: true,
                roles:[OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin], allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION]},
            {title: "Komentari", path: PATH_DASHBOARD.preview.commentsList, icon: ICONS.comments,needPrimaryUser: true,
                roles:[OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin], allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER]},
            {title: "Povezani polasci", path: PATH_DASHBOARD.preview.departuresLinkedList, icon: ICONS.dashboard,needPrimaryUser: true,
                roles:[OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin], allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION]},
            {title: "Istorija", path: PATH_DASHBOARD.preview.cancelledTripsHistory, icon: ICONS.dashboard, needPrimaryUser: true,
                roles:[OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin], allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                children: [
                    {title: "Otkazani polasci", path: PATH_DASHBOARD.preview.cancelledTripsHistory},
                    {title: "Popusti", path: PATH_DASHBOARD.preview.ratesHistory},
                    {title: "Izuzeci polazaka", path: PATH_DASHBOARD.preview.tripExceptionHistory},
                ]},
            {title: "Peronizacija", path: PATH_DASHBOARD.preview.peronizationStatus, icon: ICONS.dashboard,needPrimaryUser: true,
                roles:[OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER]},
        ]
    },
    {
        subheader: "Administracija stanice i sopstvenog prevoza",
        roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
        needPrimaryUser: false,
        allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
        items: [
            {
                title: "Prevoznici",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.carriers.root,
                icon: ICONS.carrier,
                children: [
                    {title: "Lista prevoznika", path: PATH_DASHBOARD.carriers.list},
                    {title: "Dodavanje prevoznika", path: PATH_DASHBOARD.carriers.new}
                ]
            },
            {
                title: "Vozila - sopstvena",
                needPrimaryUser: false,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.bus.root,
                icon: ICONS.bus,
                children: [
                    {title: "Lista vozila", path: PATH_DASHBOARD.bus.list},
                    {title: "Dodavanje vozila", path: PATH_DASHBOARD.bus.new},
                ]
            },
            {
                title: "Vozila- sopstvena",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.bus.root,
                icon: ICONS.bus,
                children: [
                    {title: "Lista vozila", path: PATH_DASHBOARD.bus.list},
                    {title: "Dodavanje vozila", path: PATH_DASHBOARD.bus.new},
                ]
            },
            {
                title: "Cenovnik - sopstveni",
                needPrimaryUser: false,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.priceList.root,
                icon: ICONS.priceList,
                children: [
                    {title: "Lista cenovnika", path: PATH_DASHBOARD.priceList.list},
                    {title: "Dodavanje cenovnika", path: PATH_DASHBOARD.priceList.new},
                    {title: "Lista stanica po cenovniku", path: PATH_DASHBOARD.priceList.stationsList},
                    {title: "Vezivanje cenovnika", path: PATH_DASHBOARD.priceList.linkPriceTrip},
                ]
            },
            {
                title: "Cenovnik - sopstveni",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.priceList.root,
                icon: ICONS.priceList,
                children: [
                    {title: "Lista cenovnika", path: PATH_DASHBOARD.priceList.list},
                    {title: "Dodavanje cenovnika", path: PATH_DASHBOARD.priceList.new},
                    {title: "Lista stanica po cenovniku", path: PATH_DASHBOARD.priceList.stationsList},
                    {title: "Vezivanje cenovnika", path: PATH_DASHBOARD.priceList.linkPriceTrip},
                ]
            },
            {
                title: "Artikli",
                needPrimaryUser: true,
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.priceList.root,
                icon: ICONS.cart,
                children: [
                    {
                        title: "Lista artikala",
                        path: PATH_DASHBOARD.items.list
                    },
                    {
                        title: "Dodavanje artikla",
                        path: PATH_DASHBOARD.items.new
                    },
                    {
                        title: "Cene po cenovniku",
                        path: PATH_DASHBOARD.items.rateCardItems
                    },
                ]
            },
            {
                title: "Praznici",
                needPrimaryUser: false,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.holidays.root,
                icon: ICONS.priceList,
                children: [
                    {title: "Lista praznika", path: PATH_DASHBOARD.holidays.list},
                    {title: "Dodavanje praznika", path: PATH_DASHBOARD.holidays.new},
                ]
            },
            {
                title: "Praznici",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.CARRIER, USER_TYPES_GROUP.BUS_STATION],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.holidays.root,
                icon: ICONS.priceList,
                children: [
                    {title: "Lista praznika", path: PATH_DASHBOARD.holidays.list},
                    {title: "Dodavanje praznika", path: PATH_DASHBOARD.holidays.new},
                ]
            },
            {
                title: "Relacije - sopstvene",
                needPrimaryUser: false,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.linesList.root,
                icon: ICONS.relations,
                children: [
                    {title: "Lista relacija", path: PATH_DASHBOARD.linesList.list},
                    {title: "Dodavanje relacije", path: PATH_DASHBOARD.linesList.new},
                    {title: "Lista isključenih stanica", path: PATH_DASHBOARD.disabledLineStations.list},
                    {title: "Isključi stanicu", path: PATH_DASHBOARD.disabledLineStations.new},
                ]
            },
            {
                title: "Relacije - sopstvene",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.CARRIER, USER_TYPES_GROUP.BUS_STATION],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.linesList.root,
                icon: ICONS.relations,
                children: [
                    {title: "Lista relacija", path: PATH_DASHBOARD.linesList.list},
                    {title: "Dodavanje relacije", path: PATH_DASHBOARD.linesList.new},
                    {title: "Lista isključenih stanica", path: PATH_DASHBOARD.disabledLineStations.list},
                    {title: "Isključi stanicu", path: PATH_DASHBOARD.disabledLineStations.new},
                ]
            },
            {
                title: "Dodeljivanje relacija stanicama",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.CARRIER, USER_TYPES_GROUP.BUS_STATION],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.stationLineAssignment.list,
                icon: ICONS.relations,
            },
            {
                title: "Red vožnje i polasci - sopstveni",
                needPrimaryUser: false,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.departuresList.root,
                icon: ICONS.departures,
                children: [
                    {title: "Lista polazaka", path: PATH_DASHBOARD.departuresList.list},
                    {title: "Dodavanje polazaka", path: PATH_DASHBOARD.departuresList.new},
                    {title: "Lista alotmana", path: PATH_DASHBOARD.allotment.list},
                    {title: "Dodavanje alotmana", path: PATH_DASHBOARD.allotment.new},
                    {title: "Povezani polasci", path: PATH_DASHBOARD.departuresList.departuresLinkedList},
                    {title: "Vezivanje polazaka", path: PATH_DASHBOARD.departuresList.linked},
                    {title: "Izuzeci stanica na polascima", path: PATH_DASHBOARD.departuresList.departuresExceptions},
                ]
            },
            {
                title: "Red vožnje i polasci - sopstveni",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.CARRIER, USER_TYPES_GROUP.BUS_STATION],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.departuresList.root,
                icon: ICONS.departures,
                children: [
                    {title: "Lista polazaka", path: PATH_DASHBOARD.departuresList.list},
                    {title: "Dodavanje polazaka", path: PATH_DASHBOARD.departuresList.new},
                    {title: "Lista alotmana", path: PATH_DASHBOARD.allotment.list},
                    {title: "Dodavanje alotmana", path: PATH_DASHBOARD.allotment.new},
                    {title: "Povezani polasci", path: PATH_DASHBOARD.departuresList.departuresLinkedList},
                    {title: "Vezivanje polazaka", path: PATH_DASHBOARD.departuresList.linked},
                    {title: "Izuzeci stanica na polascima", path: PATH_DASHBOARD.departuresList.departuresExceptions},
                ]
            },
            // {
            //     title: "Alotmani - sopstveni",
            //     needPrimaryUser: true,
            //     allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION],
            //     roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
            //     path: PATH_DASHBOARD.allotment.root,
            //     icon: ICONS.relations,
            //     children: [
            //         {title: "Dodeljeni alotmani", path: PATH_DASHBOARD.allotment.assigned},
            //         {title: "Dodeljivanje alotmana", path: PATH_DASHBOARD.allotment.assign},
            //     ]
            // },
            {
                title: "Status slobodnih mesta",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.tripSeatStatus.root,
                icon: ICONS.seats,
                children: [
                    {title: "Dodeljeni kapaciteti", path: PATH_DASHBOARD.tripSeatStatus.list},
                ]
            },
            {
                title: "Itinerer - sopstveni",
                needPrimaryUser: false,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.timesList.root,
                icon: ICONS.times,
                children: [
                    {title: "Lista Itinerera", path: PATH_DASHBOARD.timesList.list},
                    // {title: "Dodavanje vremena", path: PATH_DASHBOARD.timesList.new},
                ]
            },
            {
                title: "Itinerer - sopstveni",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.CARRIER, USER_TYPES_GROUP.BUS_STATION],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.timesList.root,
                icon: ICONS.times,
                children: [
                    {title: "Lista Itinerera", path: PATH_DASHBOARD.timesList.list},
                    // {title: "Dodavanje vremena", path: PATH_DASHBOARD.timesList.new},
                ]
            },
            {
                title: "Popusti - sopstveni",
                needPrimaryUser: false,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.discounts.root,
                icon: ICONS.discount,
                children: [
                    {title: "Popusti", path: PATH_DASHBOARD.discounts.list},
                    {title: "Dodavanje popusta", path: PATH_DASHBOARD.discounts.new},
                ]
            },
            {
                title: "Popusti - sopstveni",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.CARRIER, USER_TYPES_GROUP.BUS_STATION],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.discounts.root,
                icon: ICONS.discount,
                children: [
                    {title: "Popusti", path: PATH_DASHBOARD.discounts.list},
                    {title: "Dodavanje popusta", path: PATH_DASHBOARD.discounts.new},
                ]
            },
            {
                title: "Povlastice",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.privileges.root,
                icon: ICONS.discount,
                children: [
                    {title: "Povlastice", path: PATH_DASHBOARD.privileges.list},
                    {title: "Dodavanje povlastice", path: PATH_DASHBOARD.privileges.new},
                    {title: "Tipovi povlastice", path: PATH_DASHBOARD.privileges.listDisabilities},
                    // {title: "Dodavanje tipa povlastice", path: PATH_DASHBOARD.privileges.newDisability},
                ]
            },
            {
                title: "Akcije",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.actions.root,
                icon: ICONS.times,
                children: [
                    {title: "Lista akcija", path: PATH_DASHBOARD.actions.list},
                    {title: "Dodavanje akcije", path: PATH_DASHBOARD.actions.new},
                    {title: "Lista vrednosti akcije", path: PATH_DASHBOARD.actions.actionValueList},
                    {title: "Dodavanje vrednosti akcije", path: PATH_DASHBOARD.actions.actionValueNew},
                ]
            },
            {
                title: "Obaveštenja",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.promoNotifications.root,
                icon: ICONS.promoNotifications,
                children: [
                    {title: "Objave i istorija", path: PATH_DASHBOARD.promoNotifications.list},
                ]
            },
            {
                title: "Stanice",
                needPrimaryUser: true,
                roles: [OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.admin],
                path: PATH_DASHBOARD.stationList.root,
                icon: ICONS.stationList,
                children: [
                    {title: "Lista stanica", path: PATH_DASHBOARD.stationList.list},
                    {title: "Dodavanje stanice", path: PATH_DASHBOARD.stationList.new},
                ]
            },
            {
                title: "Lokacije",
                needPrimaryUser: true,
                roles: [OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.admin],
                path: PATH_DASHBOARD.locationList.root,
                icon: ICONS.locations,
                children: [
                    {title: "Lista lokacija", path: PATH_DASHBOARD.locationList.list},
                    {title: "Dodavanje lokacija", path: PATH_DASHBOARD.locationList.new},
                ]
            },
            {
                needPrimaryUser: true,
                title: "Peroni",
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.platforms.root,
                icon: ICONS.platforms,
                children: [
                    {title: "Lista perona", path: PATH_DASHBOARD.platforms.list},
                    {title: "Dodavanje perona", path: PATH_DASHBOARD.platforms.new},
                    {title: "Zauzetost perona", path: PATH_DASHBOARD.platforms.busyness},
                ]
            },
            {
                title: "Baza kupaca",
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.CARRIER,USER_TYPES_GROUP.BUS_STATION],
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.customers.root,
                icon: ICONS.customers,
                children: [
                    {title: "Lista kupaca", path: PATH_DASHBOARD.customers.list},
                    {title: "Dodavanje kupaca", path: PATH_DASHBOARD.customers.new}
                ]
            },
            {
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.CARRIER,USER_TYPES_GROUP.BUS_STATION],
                title: "Zaposleni",
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.operators.root,
                icon: ICONS.customers,
                children: [
                    {title: "Lista zaposlenih", path: PATH_DASHBOARD.operators.list},
                    {title: "Dodavanje zaposlenog", path: PATH_DASHBOARD.operators.new}
                ]
            },
            {
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION],
                title: "Komentari",
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.comments.root,
                icon: ICONS.comments,
                children: [
                    {title: "Lista komentara", path: PATH_DASHBOARD.comments.list},
                ]
            },
            {
                needPrimaryUser: true,
                allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION],
                title: "Statusi polazaka",
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.departuresStatusList.root,
                icon: ICONS.customers,
                children: [
                    {title: "Statusi polazaka", path: PATH_DASHBOARD.departuresStatusList.list},
                ]
            },
            // {
            //     title: "Osiguranja",
            //     roles: [OPERATORS_GROUP.admin],
            //     path: PATH_DASHBOARD.insurance.root,
            //     icon: ICONS.insurance,
            //     children: [
            //         {title: "Lista osiguranja", path: PATH_DASHBOARD.insurance.list},
            //         {title: "Dodavanje osiguranja", path: PATH_DASHBOARD.insurance.new}
            //     ]
            // },
        ]
    },

    {
        subheader: "Saobraćajni dnevnik",
        needPrimaryUser: true,
        allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION],
        roles: ALL_ROLES,
        items: [
            {
                title: "Otpravnik",
                needPrimaryUser: true,
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.operator, OPERATORS_GROUP.dispatcher,
                    OPERATORS_GROUP.informer],
                path: PATH_DASHBOARD.otpravnik.root,
                icon: ICONS.carrier,
                children: [
                    {title: "Saobraćajni dnevnik polazaka/dolazaka", path: PATH_DASHBOARD.otpravnik.list, roles:
                            [OPERATORS_GROUP.operator, OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.admin,
                                OPERATORS_GROUP.informer]},
                    {title: "Vanredne linije/parking", path: PATH_DASHBOARD.otpravnik.other, roles:
                            [OPERATORS_GROUP.operator, OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.admin,
                               ]},
                    {title: "Objava Polazaka/Dolazaka", path: PATH_DASHBOARD.otpravnik.publisher, roles:
                            [OPERATORS_GROUP.operator, OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.admin,
                                ]},
                    {title: "Neiskorišćene tablice", path: PATH_DASHBOARD.otpravnik.unusedCameraEvents, roles:
                            [OPERATORS_GROUP.operator, OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.admin,
                                ]},
                    {title: "Dodeljene tablice", path: PATH_DASHBOARD.otpravnik.trafficLogs, roles:
                            [OPERATORS_GROUP.operator, OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.admin,
                            ]},
                    {title: "Dnevnik povezivanja", path: PATH_DASHBOARD.otpravnik.actionLog, roles:
                            [OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.admin]},
                    {title: "Dodavanje polaska/dolaska", path: PATH_DASHBOARD.otpravnik.new, roles:
                            [OPERATORS_GROUP.dispatcher, OPERATORS_GROUP.superAdmin, OPERATORS_GROUP.admin]}
                ]
            },
            {
                title: "Održani polasci / dolasci",
                needPrimaryUser: true,
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.scheduledDepAndArr.root,
                icon: ICONS.carrier,
                children: [
                    {title: "Evidencija polazaka i dolazaka", path: PATH_DASHBOARD.scheduledDepAndArr.list},
                ]
            },
        ]
    },
    {
        subheader: "Kartice prevoznika",
        allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION, USER_TYPES_GROUP.CARRIER],
        needPrimaryUser: true,
        items: [

            {
                title: "Peronizacija",
                needPrimaryUser: true,
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.peronization.root,
                icon: ICONS.carrier,
                children: [
                    {title: "Cenovnik peronizacije", path: PATH_DASHBOARD.peronization.price},
                    {title: "Izveštaj prijema i otpreme", path: PATH_DASHBOARD.peronization.list},
                    {title: "Izveštaj parking", path: PATH_DASHBOARD.parking.list},
                    {title: "Parking usluge", path: PATH_DASHBOARD.parkingServices.list},
                ]
            },
            {
                title: "Obračun prihoda prevoznika",
                needPrimaryUser: true,
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.carrierReport.root,
                icon: ICONS.carrier,
                children: [
                    {title: "Sumarni izveštaj o prodaji za prevoznika", path: PATH_DASHBOARD.carrierReport.sumarized},
                    {title: "Detaljni izveštaj o prodaji za prevoznika", path: PATH_DASHBOARD.carrierReport.detailed},
                    {title: "Izveštaj o prodatim kartama", path: PATH_DASHBOARD.carrierReport.tickets},
                    {title: "Izveštaj vraćenih karata", path: PATH_DASHBOARD.carrierReport.returnTickets},
                    {title: "Izveštaj validiranih karata", path: PATH_DASHBOARD.carrierReport.validatedTickets},
                    {title: "Izveštaj povlašćenih karata", path: PATH_DASHBOARD.carrierReport.privilegesTickets},
                    {title: "Izveštaj karata sa popustom", path: PATH_DASHBOARD.carrierReport.discountedTickets},
                    {title: "Izveštaj sumiranih karata", path: PATH_DASHBOARD.carrierReport.ticketOperatorStats},
                    {title: "Finansijski izveštaj o prodaji karata", path: PATH_DASHBOARD.carrierReport.ticketSalesFinancialReport},
                    {title: "Međunarodni izveštaj", path: PATH_DASHBOARD.reports.internationalReport},
                    {title: "Bela lista - izveštaj", path: PATH_DASHBOARD.carrierReport.whiteList},
                ]
            },
            {
                title: "Drugi kanali prodaje",
                needPrimaryUser: true,
                // Samo prevoznik čije alotmane prodaje neki registrovan kanal.
                needSalesChannel: true,
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.otherSalesChannels.root,
                icon: ICONS.carrier,
                children: [
                    {title: "FIDKP — Finansijski izveštaj drugih kanala prodaje", path: PATH_DASHBOARD.otherSalesChannels.fidkp},
                ]
            },
        ]
    },
    {
        subheader: "Kartica AS",
        allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION],
        needPrimaryUser: true,
        items: [
            {
                title: "Obračuni i Izveštaji",
                needPrimaryUser: true,
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.commissionCalculation.root,
                icon: ICONS.reports,
                children: [
                    {title: "Obračun provizija", path: PATH_DASHBOARD.commissionCalculation.list},
                   // {title: "Izveštaj svih karata", path: PATH_DASHBOARD.commissionCalculation.allTickets},
                    {title: "Obračun prihoda za stanicu", path: PATH_DASHBOARD.commissionCalculation.incomeForStation},
                    {title: "Izveštaj staničnih usluge sumarno", path: PATH_DASHBOARD.commissionCalculation.additionalIncome},
                    {title: "Izveštaj staničnih usluge detaljno", path: PATH_DASHBOARD.commissionCalculation.additionalRevenueDetailedReport},
                    {title: "Analitika i provizije", path: PATH_DASHBOARD.commissionCalculation.analyticsAndCommissions},
                    {title: "Izveštaj o prodatim uslugama", path: PATH_DASHBOARD.servicesReport.list}
                ]
            },
        ]
    },
    {
        subheader: "Barijere",
        allowedUserTypes: [USER_TYPES_GROUP.BUS_STATION],
        needPrimaryUser: true,
        items:[
            {
                title: "Barijere",
                needPrimaryUser: true,
                roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                path: PATH_DASHBOARD.barriers.root,
                icon: ICONS.barriers,
                children: [
                    {title: "Karte", path: PATH_DASHBOARD.barriers.list},
                    {title: "Terminali", path: PATH_DASHBOARD.barriers.terminals},
                    {title: "Eksterni partneri", path: PATH_DASHBOARD.barriers.partners},
                    {title: "Izveštaji", path: PATH_DASHBOARD.barriers.reports},
                ]
            },
        ]
    },
    {
        subheader: "Izmene i zahtevi",
        needPrimaryUser: true,
        items:[
            {title: "Problemi", path: PATH_DASHBOARD.projectImprovements.bugs, icon: ICONS.bugs,needPrimaryUser: true},
            {title: "Zahtevi", path: PATH_DASHBOARD.projectImprovements.requests, icon: ICONS.requests,needPrimaryUser: true},
            {title: "Novo", path: PATH_DASHBOARD.projectImprovements.updates, icon: ICONS.updates,needPrimaryUser: true},
        ]
    }
];

